import * as React from 'react';

export const Reports = () => (
  <svg width='22px' height='28px' viewBox='0 0 22 28' version='1.1'>
    <g
      id='disbursement-reports'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-24.000000, -444.000000)'
    >
      <g
        id='reports-icon'
        transform='translate(24.000000, 444.000000)'
        className='navigation-icon-fill'
        fillRule='nonzero'
      >
        <path
          d='M16.5,19 L3.499999,19 C3.2238569,19 3,18.7761421 3,18.5 C3,18.2238579 3.2238569,18 3.499999,18 L16.5,18 C16.7761421,18 17,18.2238579 17,18.5 C17,18.7761421 16.7761421,19 16.5,19 Z'
          id='Shape'
        ></path>
        <path
          d='M16.5,22 L3.499999,22 C3.2238569,22 3,21.7761421 3,21.5 C3,21.2238579 3.2238569,21 3.499999,21 L16.5,21 C16.7761421,21 17,21.2238579 17,21.5 C17,21.7761421 16.7761421,22 16.5,22 Z'
          id='Shape'
        ></path>
        <path
          d='M16.5,25 L3.499999,25 C3.2238569,25 3,24.7761421 3,24.5 C3,24.2238579 3.2238569,24 3.499999,24 L16.5,24 C16.7761421,24 17,24.2238579 17,24.5 C17,24.7761421 16.7761421,25 16.5,25 Z'
          id='Shape'
        ></path>
        <path
          d='M21,0 L3,0 C2.4476929,0 2,0.4476929 2,1 L2,2 L1,2 C0.4476929,2 0,2.4476929 0,3 L0,27 C0,27.5522461 0.4476929,28 1,28 L19,28 C19.5523071,28 20,27.5522461 20,27 L20,26 L21,26 C21.5523071,26 22,25.5522461 22,25 L22,1 C22,0.4476929 21.5523071,0 21,0 Z M1,27 L1,3 L15,3 L15,6 C15,6.5522461 15.4477539,7 16,7 L19,7 L19,27 L1,27 Z M16,3.4141846 L18.5858154,6 L16,6 L16,3.4141846 Z M21,25 L20,25 L20,6 L16,2 L3,2 L3,1 L21,1 L21,25 Z'
          id='Shape'
        ></path>
        <path
          d='M10,5 C7.2431641,5 5,7.2431641 5,10 C5,12.7568359 7.2431641,15 10,15 C12.7568359,15 15,12.7568359 15,10 C15,7.2385864 12.7614136,5 10,5 Z M10,14.1666667 C7.70202635,14.1666667 5.83333333,12.297465 5.83333333,10 C5.83333333,7.702535 7.70202635,5.83333333 10,5.83333333 L10,10 L14.1666667,10 C14.1666667,12.297465 12.2979736,14.1666667 10,14.1666667 Z'
          id='Shape'
        ></path>
      </g>
    </g>
  </svg>
);
